import type React from 'react';

function QliroIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 449.07 449.07"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Qliro Icon</title>

      <g id="Layer_2" data-name="Layer 2">
        <g id="Lager_1" data-name="Lager 1">
          <path
            d="M230.11,246.15h102.93c23.96,0,43.35-19.39,43.35-43.35h0c0-23.96-19.39-43.35-43.35-43.35H116.03c-23.96,0-43.35,19.39-43.35,43.35h0c0,23.96,19.39,43.35,43.35,43.35h55.27c20.15,0,39.55,7.99,53.74,22.31l86.19,86.19h-86.7l-39.67-39.67c-2.41-2.41-5.58-3.68-9-3.68h-58.43c-59.83,0-109.39-47.79-109.77-107.62-.51-60.21,48.29-109.26,108.5-109.26h215.49c59.83,0,109.39,47.79,109.77,107.62.51,60.21-48.29,109.26-108.5,109.26h-32.58l-48.29-48.29c-6.59-6.72-13.94-12.17-21.93-16.86h0Z"
            fill="currentColor"
          />
        </g>
        <rect width="449.07" height="449.07" fill="none" />
      </g>
    </svg>
  );
}

export default QliroIcon;
